export const winnerEventTypes = ['Food', 'Other', 'Multi Attendee'] as const;

export const winnerEventRoles = ['Winner', 'Finalist', 'Both'] as const;

export type WinnerEventType = (typeof winnerEventTypes)[number];

export type WinnerEventRole = (typeof winnerEventRoles)[number];

export interface WinnerEvent {
  eventId: number;
  displayName: string;
  eventType: WinnerEventType;
  eventDate: string;
  startTime?: string;
  endTime?: string;
  isTimeTBD: boolean;
  role: WinnerEventRole;
  numberOfAttendees: number;
}
